import permisos, { RESOURCE_IMPORTACIONES } from '@/auth/permissions/modules/importacionesPg'
import {
    ROUTE_NIVEL_APROBACION_IMPORTACION,
    ROUTE_TERMINOS_NEGOCIACION,
} from '@/router/routes/importaciones-pg/nombres/configuracion'
import { defineMenu } from '@/utils/menu'

const { configuracion } = permisos
export default defineMenu([
    {
        title: 'importaciones.subopciones.terminos_negociacion',
        resource: RESOURCE_IMPORTACIONES,
        action: configuracion.incoterms,
        route: ROUTE_TERMINOS_NEGOCIACION,
    },
    {
        title: 'importaciones.subopciones.niveles_aprobacion',
        resource: RESOURCE_IMPORTACIONES,
        action: configuracion.nivelesAprobacion,
        route: ROUTE_NIVEL_APROBACION_IMPORTACION,
    },
])
